import ReactLoading from 'react-loading';

const Loading = () => {
    return (
        <div className='react-loading'>
            <ReactLoading type='cylon' height={'8%'} width={'8%'} />
        </div>
    )
}

export default Loading;